import * as React from "react";
const SvgFiRrConciergeBell = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M23 21H13v-2h7.343A2.66 2.66 0 0 0 23 16.343V16c0-3.029-1.268-5.955-3.479-8.027A10.9 10.9 0 0 0 13 5.043V3h1a1 1 0 0 0 0-2h-4a1 1 0 0 0 0 2h1v2.044c-5.629.509-10 5.418-10 11.299A2.66 2.66 0 0 0 3.657 19H11v2H1a1 1 0 0 0 0 2h22a1 1 0 0 0 0-2M3 16.342c0-4.923 3.689-9.018 8.399-9.323q.295-.019.588-.02h.028a8.9 8.9 0 0 1 6.138 2.432A8.91 8.91 0 0 1 21 15.999v.343a.66.66 0 0 1-.657.657H3.657A.657.657 0 0 1 3 16.342"
    />
  </svg>
);
export default SvgFiRrConciergeBell;
